<!-- Path: libs/core/shell/src/lib/layout/public/shell-layout/shell-layout.component.html -->
<div class="l-shell">
  @if (!focusRouteActive()) {
    <lib-shell-header [compactVisible]="compactHeaderVisible()"></lib-shell-header>
  }

  <lib-ui-drawer id="cart" title="Carrinho">
    <lib-ui-cart></lib-ui-cart>
  </lib-ui-drawer>

  <main class="l-container l-shell__main">
    @if (!focusRouteActive()) {
      <div class="l-shell__hero">
        <lib-hero-header
          [headline]="'Promoção relâmpago só hoje'"
          [bannerImageUrl]="heroBannerUrl"
          [promos]="heroPromos()"
          [brandImageUrl]="cfg.brandLogoUrl"
          (promoSelected)="openPromo($event)"
          (searchSubmitted)="onSearch($event)"
        ></lib-hero-header>
      </div>
    }

    <div class="l-shell__container">
      <router-outlet></router-outlet>
    </div>
  </main>

  @if (!focusRouteActive()) {
    <lib-shell-footer></lib-shell-footer>
  }
</div>